import moment from 'moment'

export default class DateService {
  static dateDisplayFormat = 'DD.MM.YYYY'
  static dateDatabaseFormat = 'YYYY-MM-DD'
  static timeDatabaseFormat = 'HH:mm:ss'
  /**
   * Converti la date du format YYYY-MM-DD au format DD.MM.YYYY
   * @param {string} date
   */
  static formatDateToDisplayFormat (date) {
    return moment(date, this.dateDatabaseFormat).format(this.dateDisplayFormat)
  }
  /**
   * Converti la date du format DD.MM.YYYY au format YYYY-MM-DD
   * @param {string} date
   */
  static formatDateToDatabaseFormat (date) {
    return moment(date, this.dateDisplayFormat).format(this.dateDatabaseFormat)
  }
  /**
   * Converti l'heure du format H:mm:ss au format "HH + 'h' + mm"
   * @param {string} time
   */
  static formatTimeToDisplayFormat (time) {
    const hours = moment(time, this.timeDatabaseFormat).format('HH')
    const minutes = moment(time, this.timeDatabaseFormat).format('mm')
    return hours + 'h' + minutes
  }
  /**
   * Converti l'heure du format "HH + 'h' + mm"  au format H:mm:ss
   * @param {string} time
   */
  static formatTimeToDatabaseFormat (time) {
    const hours = time.substring(0, 2)
    const minutes = time.substring(time.length - 2, time.length)
    return hours + ':' + minutes
  }
  /**
   * Format toutes les champs dates d'une array d'objets au format DD.MM.YYYY
   * @param {array} array
   * @param {string} formatTo - formattage de destination. Soit 'database' ou 'display'
   */
  static formatObjectArrayDatesToDisplayFormat (array, formatTo) {
    array.forEach(element => {
      Object.keys(element).forEach(property => {
        if (property === 'dateCreation' ||
        property === 'dateDetail' ||
        property === 'dateValidation' ||
        property === 'dateRemediation') {
          if (element[property]) {
            if (formatTo === 'display') {
              element[property] = this.formatDateToDisplayFormat(element[property])
            } else {
              element[property] = this.formatDateToDatabaseFormat(element[property])
            }
          }
        } else if (property === 'heureCreation' ||
        property === 'heureValidation' ||
        property === 'heureRemediation') {
          if (element[property]) {
            if (formatTo === 'display') {
              element[property] = this.formatTimeToDisplayFormat(element[property])
            } else {
              element[property] = this.formatTimeToDatabaseFormat(element[property])
            }
          }
        }
      })
    })
    return array
  }
}
